<!--
  Copyright 2026 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="qr-code-dialog-container">
  <div mat-dialog-title class="qr-code-title">
    <div i18n="@@app.labels.surveyQrCode">Survey QR code</div>

    <button class="close" mat-icon-button mat-dialog-close aria-label="close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="qr-code-wrapper" #qrCodeElement>
      <qrcode
        [qrdata]="surveyAppLink"
        [colorDark]="'#000000ff'"
        [colorLight]="'#ffffffff'"
        [elementType]="'canvas'"
        [errorCorrectionLevel]="'M'"
        [imageSrc]="'assets/img/logo.svg'"
        [imageHeight]="75"
        [imageWidth]="75"
        [margin]="2"
        [scale]="1"
        [width]="300"
      ></qrcode>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="copyQrCodeToClipboard()">
      <mat-icon>content_copy</mat-icon>

      <span i18n="@@app.labels.copyToClipboard">Copy to clipboard</span>
    </button>
  </mat-dialog-actions>
</div>
